import React, { StrictMode, useEffect } from "react";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { MutationCache, QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { colors } from "theme/foundations/colors";
import { createRoot } from "react-dom/client";

import "./i18n";

import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import AuthProviderWrapper from "./AuthProviderWrapper";
import { isDevEnvironment } from "./pages/ISSB/demoUtils";
import "./theme/global-styles.css";

// Add status marker css if we're on a dev server / local machine
if (isDevEnvironment()) {
  import("./theme/status.css");
}

const mutationCache = new MutationCache({
  //default useMutate config
});

const theme = extendTheme({
  colors,
  components: {
    Radio: {
      baseStyle: {
        container: {
          touchAction: "none",
        },
      },
    },
  },
});

/**
 * Default tanstack react-query options.
 * TODO remove code that duplicates setting these options in individual queries.
 */
const DEFAULT_QUERY_OPTIONS = {
  retryDelay: 0,
  retry: 0,
  keepPreviousData: true,
  staleTime: 1000 * 60 * 5,
  cacheTime: 1000 * 60 * 5,
  refetchOnWindowFocus: false,
  enabled: true,
};

const queryClient = new QueryClient({
  mutationCache,
  defaultOptions: {
    queries: DEFAULT_QUERY_OPTIONS,
  },
});

// Brand the js console :)

console.log("%cESG360° WebApp", "font-size: 1.5em; color: #0C3136; font-weight: bold;");

export function ScrollToTop({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const container = document.getElementById("layoutContainer");
    if (container) {
      container.scrollTo(0, 0);
    }
  }, [pathname]);

  return <>{children}</>;
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <AuthProviderWrapper />
      </ChakraProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
